import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Años de terapia sin resolver la raíz',
    cost: 'Tiempo, dinero y desgaste sin resultados duraderos'
  }, {
    without: 'Meditar sin limpiar el campo real',
    cost: 'Alivio temporal que no transforma'
  }, {
    without: 'Vínculos que siguen drenando sin herramienta',
    cost: 'Energía propia entregada sin retorno'
  }, {
    without: 'Decisiones desde el miedo y la culpa',
    cost: 'Vida construida desde una base falsa'
  }, {
    without: 'Insomnio y cansancio crónico sin protocolo',
    cost: 'Cuerpo pagando el costo emocional'
  }, {
    without: 'El mismo patrón volviendo una y otra vez',
    cost: 'Otro año igual al que acabás de tener'
  }];
  return <Section data-id="element-47">
      <div className="text-center mb-12" data-id="element-48">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[24px]" data-id="element-49">
          <span className="mr-3" data-id="element-50">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-51">
        {/* Desktop: 2-column grid */}
        <div className="hidden md:block" data-id="element-52">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-53">
            <div className="font-serif font-bold text-lg text-brand-text/80" data-id="element-54">
              Sin el Método
            </div>
            <div className="font-serif font-bold text-lg text-red-400" data-id="element-55">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-56">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-red-500/10" data-id="element-57">
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-58">
                  {row.without}
                </div>
                <div className="text-sm text-red-300/90" data-id="element-59">{row.cost}</div>
              </div>)}
          </div>
        </div>

        {/* Mobile: stacked cards */}
        <div className="md:hidden space-y-4" data-id="element-60">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl space-y-2 border-red-500/10 pt-[10px] pb-[10px] pl-[10px] pr-[10px]" data-id="element-61">
              <p className="text-sm font-medium text-brand-text/90" data-id="element-62">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-red-300/90" data-id="element-63">
                <span className="text-red-400 shrink-0" data-id="element-64">→</span>
                <span className="text-sm" data-id="element-65">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-66">
        <h3 className="md:text-3xl font-serif font-bold gold-gradient-text mb-6 text-[20px]" data-id="element-67">
          El próximo domingo puede ser completamente diferente.
        </h3>
        <p className="italic text-brand-text/80 text-[16px]" data-id="element-68">
          "El campo limpio no es el destino. Es el punto de partida." 🌟
        </p>
      </div>
    </Section>;
};